var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"returns-filter-section"},[_c('navigation-button',{staticClass:"returns-filter-button",attrs:{"color":_vm.color,"icon":_vm.icon,"label":_vm.label},on:{"click":_vm.toggle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }